import { render, staticRenderFns } from "./QuickPanel.vue?vue&type=template&id=2a748e67"
import script from "./QuickPanel.vue?vue&type=script&lang=js"
export * from "./QuickPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a748e67')) {
      api.createRecord('2a748e67', component.options)
    } else {
      api.reload('2a748e67', component.options)
    }
    module.hot.accept("./QuickPanel.vue?vue&type=template&id=2a748e67", function () {
      api.rerender('2a748e67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/offcanvas/QuickPanel.vue"
export default component.exports